import { useEffect } from 'react';
import { App as CapApp } from '@capacitor/app';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider }  from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { LangProvider }  from './contexts/LangContext';
import ProtectedRoute       from './components/ProtectedRoute';
import LoginPage            from './pages/LoginPage';
import SignupPage           from './pages/SignupPage';
import SettingsPage         from './pages/SettingsPage';
import UserProfilePage      from './pages/UserProfilePage';
import DiscoveryPage        from './pages/DiscoveryPage';
import CreateCommunityPage  from './pages/CreateCommunityPage';
import SubscriptionPage     from './pages/SubscriptionPage';
import CommunityPage        from './pages/CommunityPage';
import Shell                from './Shell';
import './App.css';

export default function App() {
  useEffect(() => {
    if (window.Capacitor) {
      const listenerPromise = CapApp.addListener('backButton', (data) => {
        if (window.__backButtonHandlers && window.__backButtonHandlers.length > 0) {
          for (let i = window.__backButtonHandlers.length - 1; i >= 0; i--) {
            const handled = window.__backButtonHandlers[i]();
            if (handled) {
              return;
            }
          }
        }
        if (data.canGoBack) {
          window.history.back();
        } else {
          CapApp.exitApp();
        }
      });

      return () => {
        listenerPromise.then(h => h.remove());
      };
    }
  }, []);

  return (
    <BrowserRouter>
      <ThemeProvider>
        <LangProvider>
          <AuthProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/"          element={<DiscoveryPage />} />
              <Route path="/discovery" element={<Navigate to="/" replace />} />
              <Route path="/login"     element={<LoginPage />} />
              <Route path="/signup"    element={<SignupPage />} />

              {/* Protected routes */}
              <Route path="/app" element={<ProtectedRoute><Shell /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
              <Route path="/subscription" element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} />
              <Route path="/create" element={<CreateCommunityPage />} />
              <Route path="/c/:slug" element={<CommunityPage />} />
              <Route path="/@:username" element={<ProtectedRoute><UserProfilePage /></ProtectedRoute>} />

              {/* Community (slug-based) — static routes above still win over :slug */}
              <Route path="/:slug" element={<ProtectedRoute><Shell /></ProtectedRoute>} />
              <Route path="/:slug/:tab" element={<ProtectedRoute><Shell /></ProtectedRoute>} />
              <Route path="/:slug/:tab/:courseId" element={<ProtectedRoute><Shell /></ProtectedRoute>} />
              <Route path="/:slug/:tab/:courseId/:lessonId" element={<ProtectedRoute><Shell /></ProtectedRoute>} />

              {/* Fallback */}
              <Route path="/*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </LangProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
